/* eslint-disable */
import { Component, Injector } from '@angular/core';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { FlowManagerService } from '../../../shared/services/flowmanager.service';
import { ApplicationActions } from '../../../actions/application.actions';
import { ApplicationProxyService } from '../../../shared/services/applicationproxy.service';
import { Validation } from '../../../shared/services/validation.service';

@Component({
  selector: 'welcome-investor',
  template: require('./welcome-investor.component.html')
})
export class WelcomeInvestorComponent {
  constructor(injector: Injector) {
    this.router = injector.get(Router);
    this.flowManager = injector.get(FlowManagerService);
    this.appActions = injector.get(ApplicationActions);
    this.appProxy = injector.get(ApplicationProxyService);
    this.validation = injector.get(Validation);
    this.stepTitle = `Welcome ${this.appActions.getData('YourInformation.firstName')}`;
    this.customerName = this.appActions.getData('YourInformation.fullName');
    this.dob = this.appActions.getData('PersonalInformation.dob');
    this.accountType = this.appActions.getData('Prepop.AccountType');

    // Get personal info from ACM
    // Todo: Utilize the previously returned data...
    this.flowManager.updatePersonalInfoACMRedux(acmComplete => {
      const prepopStepNames = [
        'personal-info',
        'personal-info-auth',
        'personal-address',
        'ssn',
        'personal-contact',
        'employment-info',
        'financial-info'
      ];
      const prepopSteps = {};
      prepopStepNames.forEach(step => {
        this.appProxy.getFormJSON(this.flowManager.getAppType(), step, { isAuth: true }, res => {
          if (res.form && res.form.inputs) {
            prepopSteps[step] = res.form;

            // Have we finished them all?
            if (Object.keys(prepopSteps).length === prepopStepNames.length) {
              prepopSteps['personal-info'].inputs.securityAnswer.showUp = false;
              prepopSteps['personal-info'].inputs.securityQuestion.showUp = false;
              prepopSteps['personal-contact'].inputs.securityAnswer.showUp = false;
              prepopSteps['personal-contact'].inputs.securityQuestion.showUp = false;
              this.prepopStepsInputs(prepopSteps);
            }
          }
        });
      });
    });
  }

  ngOnInit() {
    if (this.flowManager.promoCode !== false) {
      this.appActions.setData('PersonalInformation.promoCode', this.flowManager.promoCode);
    }
  }

  addReviewToRedux(step, input) {
    const fieldId = input.attr.id.replace(/\./, '_');
    const reviewPath = `review./${step}.${fieldId}`;
    const payload = {
      label: input.reviewLabel || input.label || fieldId,
      inputPath: input.inputPath
    };

    if (input.optionsType != null) {
      payload.optionsType = input.optionsType;
    }

    if (input.maskingType != null) {
      payload.maskingType = input.maskingType;
    }

    this.appActions.setData(reviewPath, payload);
  }

  prepopStepsInputs(steps) {
    this.flowManager.prepoppedValid = true;

    Object.keys(steps).forEach(step => {
      // Covered separately in the other calls
      if (step === 'personal-info-auth') {
        return;
      }

      _.forEach(steps[step].inputs, input => {
        if (input.showUp === true) {
          const inputValue = this.appActions.getData(input.inputPath);

          if (input.inputType === 'checkbox' && input.inputs && input.inputs.length > 0 && inputValue === true) {
            // Loop through all of the checkbox inputs
            _.forEach(input.inputs, checkboxInput => {
              const validateInput = this.validation.validate(checkboxInput.validationType, this.appActions.getData(checkboxInput.inputPath));
              if (validateInput && validateInput.state === false) {
                this.flowManager.prepoppedValid = false;
                return false; // only way to break out of _.forEach
              }
            });
          } else if (input.inputType === 'employmentShow' && this.appActions.getData('appState.showVal.employmentStatus_Show', false) === true) {
            // Loop through all of the employmentShow inputs
            _.forEach(input.inputs, employmentInput => {
              const validateInput = this.validation.validate(employmentInput.validationType, this.appActions.getData(employmentInput.inputPath));
              if (validateInput && validateInput.state === false) {
                this.flowManager.prepoppedValid = false;
                return false; // only way to break out of _.forEach
              }
            });
          } else if (input.validationType) {
            const validateInput = this.validation.validate(input.validationType, inputValue);
            if (validateInput && validateInput.state === false) {
              this.flowManager.prepoppedValid = false;
              return false; // only way to break out of _.forEach
            }
          }
        }
      });
    });

    // All good then populate the review steps
    if (this.flowManager.prepoppedValid === true) {
      // Only review personal info auth
      Object.keys(steps).forEach(step => {
        if (['personal-info-auth', 'employment-info', 'financial-info'].indexOf(step) === -1) {
          return;
        }

        _.forEach(steps[step].inputs, input => {
          if (input.inputType === 'checkbox' && input.inputs && input.inputs.length > 0) {
            this.addReviewToRedux(step, input);

            // Loop through all of the checkbox inputs
            _.forEach(input.inputs, checkboxInput => {
              this.addReviewToRedux(step, checkboxInput);
            });
          } else if (input.inputType === 'employmentShow' && this.appActions.getData('appState.showVal.employmentStatus_Show', false) === true) {
            // Loop through all of the employmentShow inputs
            _.forEach(input.inputs, employmentInput => {
              this.addReviewToRedux(step, employmentInput);
            });
          } else if (input.showUp === true && input.attr && input.attr.id && input.inputPath) {
            this.addReviewToRedux(step, input);
          }
        });

        if (steps[step].reviewTitle != null) {
          this.appActions.setData(`review./${step}.options`, {
            label: steps[step].reviewTitle,
            route: `/${step}`,
            id: steps[step].reviewTitle.replace(/\s/g, '_')
          });
        }
      });
    }
  }

  next() {
    this.router.navigate(['/select-account-type'], { queryParamsHandling: 'preserve' });
  }
}
